import { useIntl } from "react-intl";
import { useState, useEffect } from "react";
import SweetAlert2 from "react-sweetalert2";
import { LoginTab } from "../enum/LoginTab";
import { RegisterMethodTab } from "./loginTab/RegisterMethodTab";
import { RegisterTab } from "./loginTab/RegisterTab";
import { LoginFormTab } from "./loginTab/LoginFormTab";
import { ForgetPasswordTab } from "./loginTab/ForgotPasswordTab";
import { useAuth } from "./AuthInit";
import { LoginPhoneAuthTab } from "./loginTab/LoginPhoneAuthTab";
import { GoogleRegisterTab } from "./loginTab/GoogleRegisterTab";
import { fetchLogoBackground } from "../api/loginapi";
import { FiArrowLeft } from "react-icons/fi";
import { LiveChatWidget } from "@livechat/widget-react";
// import { PromotionReviewModal } from "../../common/components/PromotionReview";
import { useParams } from "react-router-dom";
import { IconButton, Button } from "@mui/material";
import { FiMessageCircle } from "react-icons/fi";
import { ChatDialog } from "./Chat.js";
import { Region } from "../../../constants/CommonConst.js";
import { shallowEqual, useSelector } from "react-redux";
import { useContactUsHelper } from "../../../utils/ContactUsHelper.js";

export const LoginRegisterDialog = ({ initialTab }) => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [bannerLists, setBannerLists] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [loginTab, setLoginTab] = useState(
    initialTab ? initialTab : LoginTab.LOGIN
  );
  const [tempAuth, setTempAuth] = useState();
  const { logout } = useAuth();
  const { credential } = useParams();
  const [isOpen, setIsOpen] = useState(false);

  const masterLayoutState = useSelector(
    ({ masterLayout }) => masterLayout,
    shallowEqual
  );

  const getLogoBackground = () => {
    fetchLogoBackground({ language: intl.locale }).then((resp) => {
      if (resp && resp.bannerLists) {
        setBannerLists(resp.bannerLists);
      }
    });
  };

  useContactUsHelper(masterLayoutState);

  useEffect(() => {
    getLogoBackground();
    // const modalTrigger = document.getElementById("modalTrigger");
    // if (modalTrigger) {
    //   modalTrigger.click();
    // }
  }, []);
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentBannerIndex((prevIndex) =>
        prevIndex === bannerLists.length - 1 ? 0 : prevIndex + 1
      );
    }, 9000);

    return () => clearInterval(intervalId);
  }, [bannerLists]);

  const handleBack = () => {
    const backTab =
      loginTab === LoginTab.REGISTER_PART_1 ||
      loginTab === LoginTab.GOOGLE_REGISTER
        ? LoginTab.REGISTER_OPTION
        : loginTab === LoginTab.REGISTER_PART_2
        ? LoginTab.REGISTER_PART_1
        : loginTab === LoginTab.FORGOT_PASSWORD_PART_2
        ? LoginTab.FORGOT_PASSWORD_PART_1
        : loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2
        ? LoginTab.LOGIN_PHONE_AUTH_STEP_1
        : LoginTab.LOGIN;

    if (
      loginTab === LoginTab.REGISTER_PART_3 ||
      loginTab === LoginTab.FORGOT_PASSWORD_PART_3 ||
      loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2
    ) {
      setSwalProps({
        show: true,
        icon: "info",
        title: intl.formatMessage({ id: "alert" }),
        text: intl.formatMessage({
          id: "backErrorDescription",
        }),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: intl.formatMessage({ id: "confirm" }),
        denyButtonText: intl.formatMessage({ id: "cancel" }),
        onConfirm: () => {
          logout();
          setLoginTab(
            loginTab === LoginTab.REGISTER_PART_3
              ? LoginTab.REGISTER_OPTION
              : LoginTab.LOGIN
          );
        },
      });
    } else {
      setLoginTab(backTab);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        backgroundImage: `url(${process.env.PUBLIC_URL}/image/loginbackground.avif?771930231)`,
        backgroundSize: "cover",
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <SweetAlert2
        {...swalProps}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
      />
      <ChatDialog />
      {/* <LiveChatWidget license="14664588" visibility="minimized" /> */}
      {/* <PromotionReviewModal />
      <div
        id="modalTrigger"
        data-bs-toggle="modal"
        data-bs-target="#promotionReviewModal"
        style={{ display: "none" }}
      ></div> */}
      <div>
        <div
          style={{
            height: "5%",
            width: "100%",
            display: "flex",
            paddingTop: "5px",
            alignItems: "flex-start",
          }}
        >
          {loginTab !== LoginTab.LOGIN &&
          loginTab !== LoginTab.REGISTER_PART_1 ? (
            <div style={{ marginLeft: "20px", marginTop: "20px" }}>
              <button
                onClick={handleBack}
                style={{ background: "none", border: "none" }}
              >
                <FiArrowLeft size={25} style={{ color: "white" }} />
              </button>
            </div>
          ) : (
            <div style={{ marginLeft: "20px", marginTop: "20px" }}>
              <button
                onClick={handleBack}
                style={{
                  background: "none",
                  border: "none",
                  color: "transparent",
                }}
                disabled={loginTab === LoginTab.LOGIN}
              >
                <FiArrowLeft size={25} />
              </button>
            </div>
          )}
        </div>
        <div style={{ height: "30%", width: "100%", position: "relative" }}>
          {bannerLists.length > 0 && (
            <>
              <img
                src={bannerLists[currentBannerIndex].imageurl}
                alt={`Banner ${currentBannerIndex + 1}`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <img
                src={process.env.PUBLIC_URL + "/image/logo.avif?940435345435"}
                alt="logo"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "200px",
                  zIndex: 1, // Ensure the logo is above the banner image
                }}
              />
            </>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <div className="col-10">
            {loginTab === LoginTab.LOGIN ? (
              <LoginFormTab
                setSwalProps={setSwalProps}
                setLoginTab={setLoginTab}
                setTempAuth={setTempAuth}
                credential={credential}
              />
            ) : loginTab === LoginTab.REGISTER_OPTION ? (
              <RegisterMethodTab setLoginTab={setLoginTab} />
            ) : loginTab === LoginTab.REGISTER_PART_1 ||
              loginTab === LoginTab.REGISTER_PART_2 ||
              loginTab === LoginTab.REGISTER_PART_3 ? (
              <RegisterTab
                setLoginTab={setLoginTab}
                setSwalProps={setSwalProps}
                loginTab={loginTab}
              />
            ) : loginTab === LoginTab.FORGOT_PASSWORD_PART_1 ||
              loginTab === LoginTab.FORGOT_PASSWORD_PART_2 ||
              loginTab === LoginTab.FORGOT_PASSWORD_PART_3 ? (
              <ForgetPasswordTab
                setLoginTab={setLoginTab}
                setSwalProps={setSwalProps}
                loginTab={loginTab}
              />
            ) : loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_1 ||
              loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2 ? (
              <LoginPhoneAuthTab
                setLoginTab={setLoginTab}
                setSwalProps={setSwalProps}
                loginTab={loginTab}
                tempAuth={tempAuth}
              />
            ) : loginTab === LoginTab.GOOGLE_REGISTER ? (
              <GoogleRegisterTab
                setLoginTab={setLoginTab}
                setSwalProps={setSwalProps}
                loginTab={loginTab}
              />
            ) : null}
          </div>
        </div>
        {masterLayoutState.contactList &&
          masterLayoutState.contactList.countrycode === Region.MALAYSIA && (
            <div
              style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 1000, // Ensure it's above other elements
              }}
            >
              <IconButton
                data-bs-toggle="modal"
                data-bs-target="#chatModal"
                style={{
                  backgroundColor: "#8000FF",
                  color: "white",
                  borderRadius: "50%",
                  width: "60px",
                  height: "60px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)", // Add shadow to make it pop
                }}
              >
                <FiMessageCircle size={28} />
              </IconButton>
            </div>
          )}
      </div>
    </div>
  );
};
